import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5765ffe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  id: "add-newuser-modal",
  "aria-labelledby": "`add-newuser-modal-label`",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "add-newuser-modal-label"
  }, "New User"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1))
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Temporary password", -1))
const _hoisted_12 = { class: "col-sm-9" }
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = ["disabled"]

import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { CognitoUser } from "@/models";
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewUserModal',
  setup(__props) {

const email = ref('');
const temporaryPassword = ref('');
const emailTouched = ref(false);
const passwordTouched = ref(false);
const invalidEmailMessage = ref('');
const invalidPasswordMessage = ref('');
const store = useStore();
const actProperty: any = inject('actProperty');
const toasted = useToast();

const addUser = (payload: { username: string; temporary_password: string }): Promise<void> =>  {
  return store.dispatch('sysadmin/addUser', payload);
};

const passwordPolicyGuide = [
  "Contains at least 1 number",
  "Contains at least 1 special character (^ $ * . [ ] { } ( ) ? - \" ! @ # % & /  , > < ' : ; | _ ~ ` + =)",
  "Contains at least 1 uppercase letter",
  "Contains at least 1 lowercase letter",
];

const reset = () => {
  email.value = '';
  temporaryPassword.value = '';
  emailTouched.value = false;
  invalidEmailMessage.value = '';
  passwordTouched.value = false;
  invalidPasswordMessage.value = '';
};

const validateEmail = (email: string) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

const setEmailTouched = () => {
  emailTouched.value = true;
};

const setPasswordTouched = () => {
  passwordTouched.value = true;
};

const emailIsValid = computed(() => {
  if (emailTouched.value) {
    const valid = validateEmail(email.value);
    invalidEmailMessage.value = valid ? '' : 'Invalid email address';
    return valid;
  }
  return true;
});

const passwordIsValid = computed(() => {
  if (passwordTouched.value) {
    const numberRe = /[0-9]/;
    const uppercaseLetterRe = /[A-Z]/;
    const lowercaseLetterRe = /[a-z]/;
    const specialCharRe = /[\^\$\*\.\[\]\{\}\(\)\?\-\"\!\@\#\%\&\/\,\>\<\'\:\;\\\|\_\~`\+=]/;
    if (
      !numberRe.test(temporaryPassword.value) ||
      !uppercaseLetterRe.test(temporaryPassword.value) ||
      !lowercaseLetterRe.test(temporaryPassword.value) ||
      !specialCharRe.test(temporaryPassword.value)
    ) {
      invalidPasswordMessage.value = 'Invalid password';
      return false;
    }
    return true;
  }
  return false;
});

const canAdd = computed(() => {
  return email.value && temporaryPassword.value && emailIsValid.value && passwordIsValid.value;
});

const add = async () => {
  addUser({
    username: email.value,
    temporary_password: temporaryPassword.value,
  }).then(() => reset())
  .catch((err: any) => actProperty.displayError(err));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (setEmailTouched()))
                }, null, 544), [
                  [_vModelText, email.value]
                ]),
                (!emailIsValid.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(invalidEmailMessage.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((temporaryPassword).value = $event)),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (setPasswordTouched()))
                }, null, 544), [
                  [_vModelText, temporaryPassword.value]
                ]),
                (!passwordIsValid.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(invalidPasswordMessage.value), 1))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(passwordPolicyGuide, (guide) => {
                  return _createElementVNode("div", {
                    key: guide,
                    style: {}
                  }, _toDisplayString(guide), 1)
                }), 64))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-dismiss": "modal",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (reset()), ["prevent"]))
          }, " Back "),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (add()), ["prevent"])),
            disabled: !canAdd.value
          }, " Add ", 8, _hoisted_15)
        ])
      ])
    ])
  ]))
}
}

})